const Styles = {
    'spinner': 'MapMarkerSpinner_spinner--47a031d8 base_container--330154d1',
    'wave': 'MapMarkerSpinner_wave--30ff281d base_layer--83e929aa',
    'marker': 'MapMarkerSpinner_marker--06def8fc base_layer--83e929aa',
    'bobbing': 'MapMarkerSpinner_bobbing--7057c361'
};

export default Styles;